<template>
    <div class="login">
        <div style="text-align: center;width: 500px;height: 350px;">
            <el-tabs v-model="activeName" :stretch='true' style="width: 350px;margin-left: 30px; ">
                <el-tab-pane label="密码登录" name="first">
                    <div class="demo-input-suffix" style="margin-top: 20px;">
                        <el-input class="input-class" style="" placeholder="请输入账号" maxlength="11" minlength="1"
                            show-word-limit="11" v-model="username">
                        </el-input>
                    </div>
                    <div class="demo-input-suffix" style="padding-top:20px;">
                        <el-input class="input-class" placeholder="请输入密码" show-password minlength="1"
                            v-model="password">
                        </el-input>
                    </div>
                    <div style="margin-top: 20px;font-size: 13px;margin-left: 30px;">
                        <el-checkbox v-model="agreeRadio" style="margin-right: 5px;"></el-checkbox>
                        <label>我已阅读并同意<a style="color:blue;font-size: 13px;"
                                href="https://org.xmygjykj.com/agreement.html">《用户服务协议》</a><a
                                style="color:blue;font-size: 13px;"
                                href="https://org.xmygjykj.com/distribution.html">《个人信息保护政策》</a></label>
                    </div>

                    <el-button type="primary" style="margin-top: 20px;width: 300px;" @click="userLogin()">登录</el-button>
                </el-tab-pane>
                <el-tab-pane label="验证码登录" name="second" style="">
                    <div class="demo-input-suffix" style="margin-top: 20px;">
                        <el-input class="input-class" placeholder="请输入账号" maxlength="11" show-word-limit="11"
                            minlength="1" v-model="userPhone">
                        </el-input>
                    </div>
                    <div style="text-align: left;margin-left: 30px;font-size: 12px; margin-top: 5px;color: #b1b3b9;">
                        未注册用户登录后自动注册
                    </div>
                    <div class="demo-input-suffix" style="padding-top:20px;">
                        <el-input class="input-class" placeholder="请输入验证码" style="width: 180px;" maxlength="6"
                            show-word-limit="6" v-model="verificationCode">
                        </el-input>
                        <el-button type="primary" :disabled="state.smsSendBtn"
                            v-text="(!state.smsSendBtn && '获取验证码') || state.time + ' s'" @click="getCaptchaCode()"
                            style="margin-left: 10px;width: 110px;"></el-button>
                    </div>
                    <div style="margin-top: 20px;font-size: 13px;margin-left: 30px;">
                        <el-checkbox v-model="agreeRadio" style="margin-right: 5px;"></el-checkbox>
                        <label>我已阅读并同意<a style="color:blue;font-size: 13px;"
                                href="https://org.xmygjykj.com/agreement.html">《用户服务协议》</a><a
                                style="color:blue;font-size: 13px;"
                                href="https://org.xmygjykj.com/distribution.html">《个人信息保护政策》</a></label>
                    </div>
                    <el-button type="primary" style="margin-top: 20px;width: 300px;"
                        @click="userPhoneLogin()">登录</el-button>
                </el-tab-pane>
            </el-tabs>
        </div>

    </div>
</template>
<script>

import {
    login,
    smslogin,
    getCaptcha,
} from '@/api/api.js';

import {
    setCookie,
    setLocalStorage,
    getLocalStorage,
    verifyPhone
} from '@/utils/util.js';



export default {
    data() {
        return {
            
            verificationCode: '',
            userPhone: '',
            agreeRadio: false,
            activeName: 'first',
            username: '',
            password: '',
            state: {
                time: 60,
                loginBtn: false,
                loginType: 0,
                smsSendBtn: false,
            },
        }
    },
    methods: {
        //验证码登录
        userPhoneLogin() {
            if (!this.agreeRadio) {
                this.$message.error('请阅读并同意以下服务条款');
                return;
            }

            if (!verifyPhone(this.userPhone)) {
                this.$message({
                    message: '请输入正确的手机号码',
                    type: 'error',
                    duration: 3000
                });
                return;
            }

            if (!this.verificationCode) {
                this.$message({
                    message: '验证码不能为空，请重新输入',
                    type: 'error',
                    duration: 3000
                });
                return;
            }
            let params = {
                phone: this.userPhone,
                smsCode: this.verificationCode,
            };
            smslogin(params).then(res => {
                if (res.code === 200) {
                    let data = res.data;
                    setLocalStorage('info', JSON.stringify(data));
                    setLocalStorage('token', data.token);
                    setCookie('token', data.token, 1);
                    setCookie("companyKey", data.companyKey, 1);
                    setLocalStorage('toHome', 1);
                    console.log("toHome:" + getLocalStorage('toHome'));
                    location.reload();
                    // window.location.href = "/";
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error',
                        duration: 1000
                    });
                }
            })
        },
        userLogin() {
            if (!this.agreeRadio) {
                this.$message.error('请阅读并同意以下服务条款');
                return;
            }

            if (!verifyPhone(this.username)) {
                this.$message({
                    message: '请输入正确的手机号码',
                    type: 'error',
                    duration: 3000
                });
                return;
            }
            if (!this.password) {
                this.$message({
                    message: '密码不能为空,请重新输入',
                    type: 'error',
                    duration: 3000
                });
                return;
            }
            let params = {
                username: this.username,
                password: this.password,
                // companyKey: 'yg_zj'
            };
            login(params).then(res => {
                if (res.code === 200) {
                    console.log('res', res)
                    let data = res.data;
                    setLocalStorage('info', JSON.stringify(data));
                    setLocalStorage('token', data.token);
                    setCookie('token', data.token, 1);
                    setCookie("companyKey", data.companyKey, 1);
                    setLocalStorage('toHome', 1);
                    console.log("toHome:" + getLocalStorage('toHome'));
                    location.reload();
                    // window.location.href = "/";
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error',
                        duration: 1000
                    });
                }
            });

        },
        getCaptchaCode() {
            if (!verifyPhone(this.userPhone)) {
                this.$message({
                    message: '请输入正确的手机号码',
                    type: 'error',
                    duration: 3000
                });
                return;
            }

            let params = {
                phone: this.userPhone,
                type: 1
            };
            getCaptcha(params).then(res => {
                if (res.code === 200) {
                    console.log(200)
                    this.state.smsSendBtn = true

                    const interval = window.setInterval(() => {
                        if (this.state.time-- <= 0) {
                            this.state.time = 60
                            this.state.smsSendBtn = false
                            window.clearInterval(interval)

                        }
                    }, 1000)
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error',
                        duration: 1000
                    });
                }
            })

        },
    }
}
</script>
<style scoped>
.input-class {
    width: 300px;
}

</style>